export const midnitePartnerUrls = {
    casinoOffer: 'https://affiliate.midnite.com/C.ashx?btag=a_3134b_326c_&affid=858&siteid=3134&adid=326&c=',
    sportsOffer: 'https://affiliate.midnite.com/C.ashx?btag=a_3133b_322c_&affid=858&siteid=3133&adid=322&c=',
} as const;
